import { requester } from "App";
import P from "components/P";
import Container from "layouts/container/Container";
import { useEffect, useState } from "react";
// import style from "./StoreConfirmYnManagement.module.css";
import CustomButton from "components/buttons/CustomButton";
import { toast } from "react-toastify";
import style from "./StoreManagement.module.css";
import { CSpinner } from "@coreui/react";
import StoreManagementDetail from "./StoreManagementDetail";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";

function StoreConfirmYnManagement() {
    const [stores, setStores] = useState();

    useEffect(() => {
        let data = {}
        requester.findAllByConfirmYn(data, (result) => {
            setStores(result.data);
        })
        // requester.findAllByConfirmYnIsTrue(data, (result) => {
        //     console.log(result.data);
        // })
    }, [])

    const onConfirmClick = (storeCode) => {
        let storeData = {
            storeCode: storeCode
        }
        requester.storeConfirm(storeData, (result) => {
            if (result.code === 0) {
                setStores(result.data);
                toast.success("승인이 완료되었습니다.", {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        })
    }

    return (
        <Container>
            <div className={style.container}>
                <div className={style.flexGrid}>
                    {stores ? stores.map((store) =>
                        <div className={style.flexBox} key={store.id}>
                            <div className={style.card}>
                                <VerticalFlex padding={"10px"}>
                                    <FlexChild>
                                        <StoreManagementDetail data={store} />
                                    </FlexChild>
                                    <FlexChild height={"initial"} alignItems={"flex-end"}>
                                        <CustomButton style={{border: "none",backgroundColor: "var(--main-color)", color: "white"}} text={"승인"} onClick={() => onConfirmClick(store.storeCode)} />
                                    </FlexChild>

                                </VerticalFlex>

                            </div>
                        </div>
                    ) :
                        <CSpinner color="primary" />
                    }
                </div>
            </div>
        </Container>
        // <Container>
        //     <Container maxWidth={1200}>
        //         <P>Store Confirm Yn Management</P>
        //         {
        //             stores && stores.map((data, index) => (
        //                 <div className={style.accordion} key={index} >
        //                     <div className={style.accordionHeader} onClick={() => toggleAccordion(index)}>
        //                         <span>{data.storeName}</span>
        //                         <span>{activeIndex === index ? '-' : '+'}</span>
        //                     </div>
        //                     <div className={`${style.accordionContent} ${activeIndex === index ? style.show : ''}`}>
        //                         {
        //                             data.machines.length > 0 ? (
        //                                 data.machines.map((machine, idx) => (
        //                                     <div>
        //                                         <P key={idx}>{machine.orderNo}</P>
        //                                         <P>{machine.deviceCode}</P>

        //                                     </div>
        //                                 ))
        //                             ) : (
        //                                 <P className={style.noMachineMessage}>등록된 기기가 없습니다</P>
        //                             )
        //                         }
        //                         {
        //                             data.machines.length > 1 &&
        //                             <CustomButton text={"승인"} onClick={() =>onConfirmClick(data.storeCode)} />
        //                         }
        //                     </div>
        //                 </div>
        //             ))
        //         }
        //     </Container>
        // </Container>
    );
}

export default StoreConfirmYnManagement;